import { Loader } from "components/common/Icons/Loader/Loader";
import { Translate } from "components/common/Translate/Translate";
import { useImageCropperCropSettings } from "components/modules/Editors/Crop/EditSettings/CropSettings/useImageCropperCropSettings";

export const ImageCropperCropBottomSection = () => {
    const { handleReset, handleCrop, isCropping } = useImageCropperCropSettings();

    const isResetting = false;

    return (
        <div className="w-full py-2 px-2 flex items-center justify-center gap-2 border-t border-t-irGray-300 dark:border-t-darkSurface-600 bg-white dark:bg-darkSurface-100 ">
            <div
                className="text-white  flex-grow py-2 text-center rounded-xl font-semibold bg-irBlue-200 hover:bg-irBlue-300"
                onClick={(e) => {
                    e.stopPropagation();
                    if (isCropping) return;
                    handleCrop();
                }}
            >
                {isCropping ? (
                    <div className="flex items-center justify-center">
                        <Loader className="stroke-white" width={20} height={20} />
                    </div>
                ) : (
                    <Translate keyName={"crop"} />
                )}
            </div>
            <div
                className="bg-white dark:bg-darkSurface-300 text-black dark:text-white border border-irGray-400 dark:border-darkSurface-200 rounded-xl px-8 py-2 font-semibold"
                onClick={(e) => {
                    e.stopPropagation();

                    handleReset();
                }}
            >
                {isResetting ? (
                    <div className="flex items-center justify-center mx-2">
                        <Loader className="stroke-black " width={20} height={20} />
                    </div>
                ) : (
                    <Translate keyName={"reset"} />
                )}
            </div>
        </div>
    );
};
